import http from "./http-common";

/**
 * It's a function that returns an object with two functions.
 * @param [myContext=null] - This is the context of the component that is calling the service.
 * @returns An object with two functions.
 */
export const ClientService = () => {
 
    const ListSurveysClientById = (idClient) => http.get(`/clients/${idClient}/surveys`);

    const PostSurvey = (idClient , bodyPostSurvey) => http.post(`/clients/${idClient}/surveys` , bodyPostSurvey);  

    const GetSurveyByIdClient = (idSurvey , idClient ) => http.get(`/clients/${idClient}/surveys/${idSurvey}`);  

    const PostAssignSurveyToRespondent = (idClient, idSurvey ,  body) =>  http.post(`clients/${idClient}/assignsurvey/${idSurvey}` , body);  

    const SenEmailRespondentsBySurvey = (idClient ,idSurvey , body ) => http.post(`clients/${idClient}/sendsurvey/${idSurvey}` , body);

    const PutSurvey = (idClientput , idSurveyput , bodyPutSurvey ) => http.put(`/clients/${idClientput}/surveys/${idSurveyput}` , bodyPutSurvey);  

    const GetListTemplatesSurveys = () => http.get(`/clients/templates`);  

    const PutQuialityAndWarningAnswer = (SurveyResponseId , bodyPutSurvey ) => http.put(`/answers/${SurveyResponseId}/quialifyandwarning` , bodyPutSurvey);  

    const ListRespondentsAnswerSurvey = (idClient, idSurvey , answerd) => http.get(`/clients/${idClient}/respondentssurvey/${idSurvey}/${answerd}`);  

    const SearchRespondent = (idClient , idSurvey , body ) => http.post(`/clients/${idClient}/search/${idSurvey}` , body);

    const DeleteSurveyResponse = (idClient , listRespondant ) => http.post(`/clients/${idClient}/deletesurveyresponse` , listRespondant );

    const DeleteSurvey = (idClient , idSurvey ) => http.delete(`/clients/${idClient}/deletesurvey/${idSurvey}`);

    const PostFocusGroup = (idClient , SurveyId , focusGroupDto ) => http.post(`/clients/${idClient}/focusgroup/${SurveyId}`, focusGroupDto);

    const PutFocusGroup = (idClient , SurveyId , FocusGroupId , focusGroupDto ) => http.put(`/clients/${idClient}/focusgroup/${SurveyId}/${FocusGroupId}`, focusGroupDto);

    const ListFocusGroupBySurvey = (idClient , SurveyId ) => http.get(`/clients/${idClient}/focusgroup/${SurveyId}`);
    
    const AssingFocusGroupSurveyResponse = (idClient , FocusGroupId , surveyResponseId ) => http.post(`/clients/${idClient}/focusgroup/${FocusGroupId}/assign/${surveyResponseId}`);

    const GetComments = (idClient , idRespondent ) => http.get(`/clients/${idClient}/commentsrespondents/${idRespondent}`);

    const PostComment = (IdClient , IdRespondent , commentDto ) => http.post(`/clients/${IdClient}/commentsrespondents/${IdRespondent}` , commentDto);

    const PutComment = (IdClient , IdComment , commentDto ) => http.put(`/clients/${IdClient}/commentsrespondents/${IdComment}` , commentDto);

    const PutAttendedConfirmed = (idClient , SurveyResponseId , SurveyResponseDto) => http.put(`/clients/${idClient}/focusgroup/${SurveyResponseId}/attendedconfirmed`, SurveyResponseDto);
 
    const AnalyticsAnswersSurvey = (idClient , SurveyId ) => http.get(`/clients/${idClient}/surveys/${SurveyId}/analyticanswers`);


    const ImportProfiles = (idClient , file) => {
        const formData = new FormData();
        formData.append("File", file);
        return  http.post(`/clients/${idClient}/import/profiles`, formData ); 
    }
    
    return {
        GetSurveyByIdClient,
        GetListTemplatesSurveys,
        ListSurveysClientById,
        PostSurvey,
        PostAssignSurveyToRespondent,
        PutSurvey,
        PutQuialityAndWarningAnswer,
        SenEmailRespondentsBySurvey,
        ListRespondentsAnswerSurvey,
        SearchRespondent,
        DeleteSurveyResponse,
        DeleteSurvey,
        PostFocusGroup,
        PutFocusGroup,
        ListFocusGroupBySurvey,
        AssingFocusGroupSurveyResponse,
        GetComments,
        PostComment,
        PutComment,
        PutAttendedConfirmed,
        ImportProfiles,
        AnalyticsAnswersSurvey
    };
};